import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { ICommercialSale } from "src/models/commercial/ICommercialSale";
import { CommercialSaleItemComponent } from "src/app/ev-map/commercial-map/commercial-sale/commercial-sales-list/commercial-sale-item.component";
import { EvTooltipModule } from "ev-tooltip";

@Component({
    selector: "commercial-cluster-popup",
    imports: [CommercialSaleItemComponent, EvTooltipModule],
    templateUrl: "./commercial-cluster-popup.component.html",
    styleUrl: "./commercial-cluster-popup.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialClusterPopupComponent {
    readonly data = input<ICommercialSale[]>();

    sales = computed(() => [...(this.data() ?? [])].sort((a, b) => (a.sortDate < b.sortDate ? 1 : -1)));
}
